import React from "react";
import { Routes, Route } from 'react-router-dom';
import Leader from "../Leader";
import LeaderTours from "../LeaderTours/LeaderTours";
import LeaderAccount from "../LeaderAccount/LeaderAccount";

export default function LeaderRoutes(){

    return(
        <Routes>
            <Route >
                <Route element={<Leader/>}>
                    <Route index element={<LeaderTours/>}/>
                </Route>
                <Route exact path={'my-account'} element={<LeaderAccount/>} />
            </Route>
        </Routes>
    )
}
